
/**
 * module-resolver.ts
 * 
 * This utility helps resolve module import issues when building for production.
 * It provides safe imports for commonly used modules that may have ESM compatibility issues.
 */

// React exports
import * as React from 'react';
export const {
  createContext,
  useContext,
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
  useReducer,
  Fragment,
  createElement,
  Component,
  memo,
  forwardRef,
  createRef,
  Children,
  isValidElement,
  cloneElement,
  StrictMode
} = React;

// React DOM exports
import * as ReactDOM from 'react-dom/client';
export const { createRoot } = ReactDOM;

// React Router exports
import * as ReactRouter from 'react-router-dom';
export const {
  BrowserRouter,
  Routes,
  Route,
  Link,
  NavLink,
  Navigate,
  useNavigate,
  useParams,
  useLocation,
  Outlet
} = ReactRouter;

// React i18next exports
import * as ReactI18next from 'react-i18next';
export const {
  useTranslation,
  initReactI18next,
  Trans
} = ReactI18next;

// Supabase exports
import * as SupabaseJs from '@supabase/supabase-js';
export const {
  createClient
} = SupabaseJs;

// Export types for convenience
export type { ReactNode, FC, PropsWithChildren } from 'react';
export type { Session } from '@supabase/supabase-js';
